import { useState } from 'react'
import { RhyBusButton } from '@rhybus/button'
import { RhyBusPopOver } from '@rhybus/popover'
import { RhyBusTextArea } from '@rhybus/form-controls'
import { generateTrainingItem } from '../../../services/detailview'
import { ACTIVITY_ID, triggerCaseNotifications } from '../../../services/notificationUtils'
import { STATUS_CODE_TRAINIG } from '../../../config/configuration'

type GenerateFundingButtonProps = {
    trainingTrackGUID: string
    trainingTrackId: string
    currentStatusCode: number | null
    userRole: string
    me: any
    onSuccess?: () => void
}

export default function GenerateFundingButton({ trainingTrackGUID, trainingTrackId, currentStatusCode, userRole, me, onSuccess }: GenerateFundingButtonProps) {
    const [visible, setVisible] = useState(false)
    const [comment, setComment] = useState('')
    const [commentError, setCommentError] = useState('')
    const [loading, setLoading] = useState(false)

    const handleOk = async () => {
        if (!comment.trim()) {
            setCommentError('Comments are required')
            return
        }
        setLoading(true)
        const success = await generateTrainingItem(trainingTrackGUID, trainingTrackId, comment, currentStatusCode, userRole, me)
        await triggerCaseNotifications(
            trainingTrackGUID,
            //`Training ${trainingTrackId} has been SeatValidation by ${me?.profileName}`,
            `Training Track ${trainingTrackId} has been moved to Execution by ${me?.profileName}.`,
            ACTIVITY_ID.TrainingSeatValidation,
            STATUS_CODE_TRAINIG.seatValidation,
            me?.email,
        )
        setLoading(false)
        if (success) {
            setVisible(false)
            setComment('')
            setCommentError('')
            onSuccess?.()
        }
    }

    return (
        <RhyBusPopOver
            placement="bottom-left"
            trigger="click"
            popoverclassName="detail-view-approve-popover action-btn-popover popup-md"
            visible={visible}
            onVisibleChange={setVisible}
            content={
                <div className="d-flex flex-column gap-3 detail-view-popover-form">
                    <RhyBusTextArea
                        id="generate-funding-comments"
                        label="Comments"
                        value={comment}
                        rows={6}
                        isMandatory
                        error={commentError ? true : false}
                        errorMessage={commentError ? commentError : ''}
                        placeholder="Enter comments"
                        labelClassName='inter-medium font-14'
                        info="Add notes for the selected status update"
                        tooltipPlacement="top"
                        onChange={(e: any) => {
                            setComment(e.target.value)
                            if (e.target.value.trim()) setCommentError('')
                        }}
                    />
                </div>
            }
            footer={
                <div className="d-flex justify-content-end gap-2">
                    <RhyBusButton label="Ok" variant="primary" leftIcon='icon-rb-checked' size="md"
                        onClick={handleOk}
                        disabled={loading}
                    />
                    <RhyBusButton label="Cancel" variant="primary" leftIcon='icon-rb-close color-primary font-10' size="md"
                        onClick={() => { setVisible(false); setComment(''); setCommentError('') }}
                        style={{ '--rb-btn-bg': '#FFFFFF', '--rb-btn-border': '#BACBD9', '--rb-btn-text': '#596F80', '--rb-btn-hover-bg': '#fff', '--rb-btn-active-bg': '#fff', '--rb-btn-hover-border': '#BACBD9' }}
                    />
                </div>
            }
        >
            <RhyBusButton
                label="Generate Funding"
                leftIcon="icon-rb-checked font-16"
                variant="primary"
                pill={true}
                className='approve-button'
                ariaLabel="Generate Funding"
                style={{ '--rb-btn-bg': '#627906' }}
            />
        </RhyBusPopOver>
    )
}
